var Pixel = Pixel || {};

Pixel.Facebook = (function (PixelBase) {
    var Facebook = PixelBase.extend({
    	initialize: function (opts) {
		    opts = opts || {};
		    this._currency = opts.currency;
            this._getAPI()('init', this._id);
    	},

    	productPageView: function (productData) {
    		this._track('ViewContent', {
    			value: this._priceStringToFloat(productData.UserPrice),
    			currency: this._currency,
    			content_name: productData.Name,
    			content_type: 'product',
    			content_ids: [productData.ID]
		    });
    	},

    	addToCart: function (productData) {
    		this._track('AddToCart', {
    			value: this._priceStringToFloat(productData.UserPrice),
    			currency: this._currency,
    			content_name: productData.Name,
    			content_type: 'product',
    			content_ids: [productData.ID]
    		});
    	},

        registrationView: function() {
            this._track('Lead');			
        },

        registrationSuccess: function () {
            this._track('CompleteRegistration');
        },

        purchaseSuccess: function (opts) {
            opts = opts || {};
            var data = opts.OrderInfoResult || {};
            var contents = [];

            if (data.Items) {
                contents = data.Items.map(function(item) {
                    return item.ID || item.Sku;
                });
            }

            this._track('Purchase', {
                content_type: 'product',
                value: opts.totalValue || data.Total || 0.0,
                currency: this._currency,
                contents: contents
            });
        },

        _getAPI: function () {
            return this._api || window.fbq;
        },

        _track: function(name, opts) {
            this._getAPI()('track', name, opts);
        }
    });

    return Facebook;
})(Pixel.PixelBase);

!function (Pixel, GlobalSettings) {
    if (!GlobalSettings.TPCFE) {
        return;
    }

    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }; if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
    }(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js');

    new Pixel.Facebook({
    	id: GlobalSettings.TPCFI,
    	currency: GlobalSettings.Currency
    });
}(Pixel, GlobalSettings);
